<template>
    <div>
        <h3 class="big-title">商品详情>></h3>
        <div class="wrap">
            <div class="box">
                <div class="top ">
                    <div class="img-box">
                        <el-image class="img" :src="rImg(m.image)" fit="cover" :preview-src-list="rBigImg([m.image])">
                            <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
                        </el-image>
                    </div>
                    <div class="content">
                        <h3 class="title">{{ m.name }}</h3>
                        <p class="item">描述：<span>{{ m.description }}</span></p>
                        <p class="item">售价：<span class="price">￥{{ m.price }}</span></p>
                        <p class="item">已售：<span>{{ m.sales }}</span></p>
                        <p class="item">浏览：<span>{{ m.visit_num }}</span></p>
                        <p class="item">库存：<span>{{ m.stock }}</span></p>
                        <p class="item">数量： <el-input-number v-model="num" :min="1" :max="m.stock" label="请输入数量"></el-input-number>
                        </p>
                    </div>
                </div>
                <payList @setPay="setPay"></payList>
                <div class="bottom flex-c">
                    <el-button round class="app-btn" @click="submit()">立即下单</el-button>
                </div>
            </div>
            <h3 class="box-title">服务</h3>
            <div class="box">
                <p>极速退款</p>
            </div>
            <h3 class="box-title">更多细节</h3>
            <div class="box">
                <pre class="des" v-html="m.detail"></pre>
            </div>
            <!-- <h3 class="box-title">温馨提示</h3>
            <div class="box" v-html="des"></div> -->
        </div>
    </div>
</template>

<script>
    import payList from "@components/common/pay";
    export default {
        components: {
            payList,
        },
        data() {
            return {
                id: "",
                des: "",
                method: 2, // 2支付宝 3微信
                m: {},
                num: 1
            };
        },
        created() {
            // 在组件实例处理完所有与状态相关的选项后调用。
            this.id = this.$route.query.id;
            this.getData();
            this.getPage();
        },
        mounted() {
            // 在组件被挂载之后调用。
        },
        methods: {
            setPay(t) {},
            // 获取详情
            async getData() {
                let {
                    ret
                } = await this.$y_ajax("api/mall.goods/goodsDetail", {
                    goods_id: this.id,
                    score: 0,
                    user_id: this.$y_getKey("userid"),
                });
                this.m = ret;
            },
            // 单页内容 温馨提示
            async getPage() {
                let {
                    data
                } = await this.$y_ajax("api/page/view", {
                    id: 34
                });
                this.des = data.body;
            },
            // 下单
            async submit() {
                this.$y_msg("请先登录");
            },
        },
        computed: {
            // 计算属性
        },
        watch: {
            // 监听
        },
    };
</script>

<style lang="less" scoped>
    @import "@assets/less/des.less";



    .box .top .img-box {
        margin-right: 30px;
    }

    .box .top .img-box .img {
        width: 100%;
    }

    .tag-box {
        .tag {
            background: transparent;
            color: #cd7dfe;
            border: 1px solid;
            margin-right: 5px;
        }
    }

    .des {
        word-break: break-all;
        white-space: pre-wrap;
        word-wrap: break-word;
        font-size: 16px;
        line-height: 1.5;
        text-align: center;

        img {
            width: 100%;
        }
    }

    .item {
        font-size: 18px;
        padding-top: 20px;

        span {
            color: #777;
        }

        .price {
            color: #cd7dfe;
            font-size: 30px;
        }
    }
</style>